export default __webpack_public_path__ + "static/media/bacqueville9.85994c3a.jpg";